// extracted by mini-css-extract-plugin
module.exports = {"root":"EditListingServiceInfoPanel_root__2btUL","form":"EditListingServiceInfoPanel_form__1KdXx","title":"EditListingServiceInfoPanel_title__155O5"};